import axios from "axios";

import { baseURL } from "../../../utils/http/http-common";

export const getTeacherFinalAssessmentApiCall = async (teacherId) => {
  const authToken = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${baseURL}/FinalAssessment/GetFinalAssessmentTeacherData/${teacherId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    return response;
  } catch (error) {
    return error?.config?.data;
  }
};

export const downloadCertificateApiCall = async (teacherId) => {
  const authToken = localStorage.getItem("token");

  try {
    const response = await axios.get(
      `${baseURL}/FinalAssessment/DownloadCertificate/${teacherId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
        responseType: "blob",
      }
    );

    return response;
  } catch (error) {
    return error?.config?.data;
  }
};
